export default function ErrorPage({
                                  reset,
                              }: {
    reset: () => void
}) {

    return (
        <div className="uk-container mg-t-24">
            <h2>Что-то пошло не так</h2>
            <button
                onClick={() => reset()}
            >
                Перезагрузить страницу
            </button>
        </div>
    )
}